export const isOtpGenerateSuccess = (payload) =>
  Boolean(payload?.status?.success);

export const getOtpErrorMessage = (payload) => {
  const statusCode = payload?.statusCode;

  if (statusCode === 429) {
    return (
      payload?.message || "Rate limit exceeded. Please try after sometime."
    );
  }

  if (statusCode === 400) {
    return "Something went wrong, please try again";
  }

  return (
    payload?.status?.message ||
    payload?.message ||
    "Failed to generate OTP. Please try again."
  );
};
